"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Root = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tvisibility: ", ";\n\t", ";\n\tposition: relative;\n\tpointer-events: none;\n\twidth: 100%;\n\theight: 100%;\n\t\n\t", ";\n"], ["\n\tvisibility: ", ";\n\t",
    ";\n\tposition: relative;\n\tpointer-events: none;\n\twidth: 100%;\n\theight: 100%;\n\t\n\t", ";\n"])), function (props) { return props.show ? 'visible' : 'hidden'; }, function (props) { return !props.show && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\ttransition: visibility 0s linear 0.2s;\n\t\t"], ["\n\t\t\ttransition: visibility 0s linear 0.2s;\n\t\t"]))); }, function (props) { return function (props) { return props.theme.drawer.container; }; });
var Panel = styled_components_1.default.div.attrs(function (props) { return ({ style: { height: (props.size * 100) + '%' } }); })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\t\n\tbackground-color: white;\n\toverflow: hidden;\n\tpointer-events: initial;\n\ttext-align: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: nowrap;\n\talign-content: center;\n\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\n\tz-index: 100;\n\t\n\tborder-top: ", ";\n\n\t@media (hover: hover) {\n\t\theight: ", "%;\n\t}\n\n\t@media (hover: none) {\n\t\t", "\n\t\t", "\n\t}\n\n\t", ";\n"], ["\t\n\tbackground-color: white;\n\toverflow: hidden;\n\tpointer-events: initial;\n\ttext-align: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: nowrap;\n\talign-content: center;\n\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\n\tz-index: 100;\n\t\n\tborder-top: ", ";\n\n\t@media (hover: hover) {\n\t\theight: ", "%;\n\t}\n\n\t@media (hover: none) {\n\t\t",
    "\n\t\t",
    "\n\t}\n\n\t", ";\n"])), function (props) { return props.size <= 0 ? "" : "1px solid black"; }, function (props) { return props.size <= 0 ? 0 : 100; }, function (props) { return !props.resizing && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t\t\ttransition: height 0.2s ease-in-out;\n\t\t\t"], ["\n\t\t\t\ttransition: height 0.2s ease-in-out;\n\t\t\t"]))); }, function (props) { return props.size < 1 && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t\t\tborder-top-left-radius: 2.5vw;\n\t\t\t\tborder-top-right-radius: 2.5vw;\n\t\t\t\tborder: 1px solid black;\n\t\t\t"], ["\n\t\t\t\tborder-top-left-radius: 2.5vw;\n\t\t\t\tborder-top-right-radius: 2.5vw;\n\t\t\t\tborder: 1px solid black;\n\t\t\t"]))); }, function (props) { return props.theme.drawer.background; });
var Content = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\toverflow-y: auto;\n\tpadding: 0.5em;\n\n\t", ";\n"], ["\n\toverflow-y: auto;\n\tpadding: 0.5em;\n\n\t", ";\n"])), function (props) { return props.theme.drawer.contents; });
var MobileSizer = styled_components_1.default.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: none;\n\tmargin: 0px auto;\n\n\t@media (hover: none) {\n\t\tdisplay: block;\n\t\t}\n\n\t&>div {\n\t\tpadding: 20px 20px;\n\t\tbackground-image: url(", ");\n\t\tpointer-events: none;\n\t\tbackground-size: 24px 24px;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: left 8px top 8px;\n\n\t}\n\n\t", "\n"], ["\n\tdisplay: none;\n\tmargin: 0px auto;\n\n\t@media (hover: none) {\n\t\tdisplay: block;\n\t\t}\n\n\t&>div {\n\t\tpadding: 20px 20px;\n\t\tbackground-image: url(", ");\n\t\tpointer-events: none;\n\t\tbackground-size: 24px 24px;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: left 8px top 8px;\n\n\t}\n\n\t", "\n"])), function (props) { return props.size < 1 ? 'https://image.flaticon.com/icons/svg/61/61032.svg' : 'https://image.flaticon.com/icons/svg/61/61041.svg'; }, function (props) { return props.theme.drawer.mobileSizer; });
var DesktopClose = styled_components_1.default.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tdisplay: none;\n\n\t@media (hover: hover) {\n\t\tdisplay: block;\n\t}\n\n\t&>div {\n\t\tpadding: 20px 20px;\n\t\tbackground-image: url(", ");\n\t\tpointer-events: none;\n\t\tbackground-size: 24px 24px;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: left 8px top 8px;\n\t}\n\tcursor: pointer;\n\twidth: 40px;\n\n\t", "\n"], ["\n\tdisplay: none;\n\n\t@media (hover: hover) {\n\t\tdisplay: block;\n\t}\n\n\t&>div {\n\t\tpadding: 20px 20px;\n\t\tbackground-image: url(", ");\n\t\tpointer-events: none;\n\t\tbackground-size: 24px 24px;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: left 8px top 8px;\n\t}\n\tcursor: pointer;\n\twidth: 40px;\n\n\t", "\n"])), function (props) { return props.theme.icons.close; }, function (props) { return props.theme.drawer.desktopClose; });
var trackingThreshold = 0;
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer(props) {
        var _this = _super.call(this, props) || this;
        _this.startResize = function (ev) {
            if (_this.touchIdentifier === null) {
                _this.touchIdentifier = ev.targetTouches[0].identifier;
                _this.touchStartPos = ev.targetTouches[0].pageY;
                _this.initialSize = _this.props.size;
                if (_this.mobileSizerRef.current) {
                    _this.mobileSizerRef.current.addEventListener('touchmove', _this.resize, _this.requestPassive(false));
                }
                window.addEventListener('touchmove', _this.preventScroll, _this.requestPassive(false));
            }
        };
        _this.resize = function (evt) {
            var ev = evt;
            ev.preventDefault();
            ev.stopPropagation();
            for (var touchIndex = 0; touchIndex < ev.changedTouches.length; ++touchIndex) {
                var touch = ev.changedTouches.item(touchIndex);
                if (touch && touch.identifier === _this.touchIdentifier) {
                    if (!_this.tracking && Math.abs(touch.pageY - _this.touchStartPos) >= trackingThreshold) {
                        _this.tracking = true;
                    }
                    if (_this.tracking && _this.rootRef.current) {
                        var size = _this.initialSize + ((_this.touchStartPos - touch.pageY) / _this.rootRef.current.clientHeight);
                        size = Math.min(1, Math.max(0.01, size));
                        //console.log(size);
                        _this.props.onResize(size);
                    }
                }
            }
        };
        _this.endResize = function (ev) {
            for (var touchIndex = 0; touchIndex < ev.changedTouches.length; ++touchIndex) {
                var touch = ev.changedTouches.item(touchIndex);
                if (touch && touch.identifier === _this.touchIdentifier) {
                    if (_this.tracking && _this.rootRef.current) {
                        var size = _this.initialSize + ((_this.touchStartPos - touch.pageY) / _this.rootRef.current.clientHeight);
                        size = Math.min(1, Math.max(0, size));
                        if (_this.props.snapPoints) {
                            //Could account for velocity here...
                            var closest = 0;
                            for (var _i = 0, _a = _this.props.snapPoints; _i < _a.length; _i++) {
                                var snapPoint = _a[_i];
                                if (Math.abs(snapPoint - size) < Math.abs(closest - size)) {
                                    closest = snapPoint;
                                }
                            }
                            if (Math.abs(1 - size) < Math.abs(closest - size)) {
                                closest = 1;
                            }
                            size = closest;
                        }
                        _this.props.onResize(size);
                    }
                    //console.log("Remove touchmove listener")
                    if (_this.mobileSizerRef.current) {
                        _this.mobileSizerRef.current.removeEventListener('touchmove', _this.resize);
                    }
                    window.removeEventListener('touchmove', _this.preventScroll);
                    _this.tracking = false;
                    _this.touchIdentifier = null;
                }
            }
        };
        _this.rootRef = react_1.default.createRef();
        _this.mobileSizerRef = react_1.default.createRef();
        _this.touchIdentifier = null;
        _this.touchStartPos = -1;
        _this.initialSize = 0;
        _this.tracking = false;
        return _this;
    }
    Drawer.prototype.requestPassive = function (wantPassive) {
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function () {
                    supportsPassive = true;
                    return null;
                }
            });
            var noop = function () { };
            window.addEventListener("testPassive", noop, opts);
            window.removeEventListener("testPassive", noop, opts);
        }
        catch (e) { }
        if (supportsPassive) {
            return { passive: wantPassive };
        }
        return false;
    };
    Drawer.prototype.preventScroll = function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        //console.log("Prevent Scroll")
    };
    Drawer.prototype.componentWillUnmount = function () {
        //console.log("Remove touchmove listener")
        if (this.mobileSizerRef.current) {
            this.mobileSizerRef.current.removeEventListener('touchmove', this.resize);
        }
        window.removeEventListener('touchmove', this.preventScroll);
    };
    Drawer.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(Root, { id: "drawer-root", ref: this.rootRef, show: this.props.size > 0, className: this.props.className },
            react_1.default.createElement(Panel, { id: "drawer-panel", size: this.props.size, resizing: this.tracking },
                react_1.default.createElement(MobileSizer, { ref: this.mobileSizerRef, size: this.props.size, onClick: function () { return _this.props.onResize(_this.props.size < 1 ? 1 : 0); }, onTouchStart: this.startResize, onTouchEnd: this.endResize, onTouchCancel: this.endResize, "data-automationid": "sizer" },
                    react_1.default.createElement("div", null)),
                react_1.default.createElement(DesktopClose, { onClick: function () { return _this.props.onResize(0); }, "data-automationid": "sizer" },
                    react_1.default.createElement("div", null)),
                react_1.default.createElement(Content, null, this.props.children))));
    };
    Drawer.propTypes = {
        snapPoints: prop_types_1.default.arrayOf(prop_types_1.default.number),
        size: prop_types_1.default.number.isRequired,
        onResize: prop_types_1.default.func.isRequired,
        children: prop_types_1.default.node.isRequired
    };
    Drawer.defaultProps = {
        size: 0,
        onResize: function () { },
        children: '',
    };
    return Drawer;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Drawer);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=Drawer.js.map